<template>
  <a-layout-sider class="sider" width="273">
    <div class="scroll-container">
      <setting-item title="导航栏颜色">
        <img-checkbox-group @change="setTheme">
          <img-checkbox
            img="static/img/side-bar-dark.svg"
            :checked="dark"
            value="dark"
          />
          <img-checkbox
            img="static/img/side-bar-light.svg"
            :checked="!dark"
            value="light"
          />
        </img-checkbox-group>
      </setting-item>
      <setting-item title="主题颜色">
        <color-checkbox-group :default-values="defaultValues" :multiple="false" @change="onColorChange">
          <template v-for="(color, index) in colorList">
            <color-checkbox :key="index" :color="color" :value="index + 1" />
          </template>
        </color-checkbox-group>
      </setting-item>
      <a-divider />
      <setting-item title="导航栏位置">
        <img-checkbox-group @change="setLayout">
          <img-checkbox img="static/img/side-bar-left.svg" :checked="side" value="side" />
          <img-checkbox img="static/img/side-bar-top.svg" :checked="!side" value="head" />
        </img-checkbox-group>
      </setting-item>
      <setting-item>
        <a-list :split="false">
          <a-list-item>
            固定顶栏
            <a-switch slot="actions" :checked="fixedHeader" size="small" @change="fixHeader" />
          </a-list-item>
          <a-list-item>
            固定侧边栏
            <a-switch slot="actions" :checked="fixedSiderbar" size="small" @change="fixSiderbar" />
          </a-list-item>
          <a-list-item>
            多页签模式
            <a-switch slot="actions" :checked="multipage" size="small" @change="setMultipage" />
          </a-list-item>
        </a-list>
      </setting-item>
      <setting-item title="全局字体">
        <a-select
          show-search
          placeholder="选择全局字体"
          option-filter-prop="children"
          v-model="globalFonts"
          style="width: 200px"
          :filter-option="filterOption"
          @change="setGlobalFont"
        >
          <a-select-option v-for="item in fontFamilyList" :key="item.value" :value="item.value">
            {{ item.name }}
          </a-select-option>
        </a-select>
      </setting-item>
      <setting-item title="导航栏字体">
        <a-select
          show-search
          placeholder="选择导航字体"
          option-filter-prop="children"
          v-model="fonts"
          style="width: 200px"
          :filter-option="filterOption"
          @focus="handleFocus"
          @blur="handleBlur"
          @change="setFont"
        >
          <a-select-option v-for="item in fontFamilyList" :key="item.value" :value="item.value">
            {{ item.name }}
          </a-select-option>
        </a-select>
      </setting-item>
      <a-button style="width: 100%" icon="save" @click="updateUserConfig">保存设置</a-button>
    </div>
    <div class="version-footer">
      <span>当前版本: {{ $version }}</span>
    </div>
  </a-layout-sider>
</template>

<script>
import SettingItem from './SettingItem'
import ColorCheckbox from '../checkbox/ColorCheckbox'
import ImgCheckbox from '../checkbox/ImgCheckbox'
import { updateTheme } from '@/utils/color'
import { mapState, mapMutations } from 'vuex'

const ColorCheckboxGroup = ColorCheckbox.Group
const ImgCheckboxGroup = ImgCheckbox.Group

export default {
  name: 'Setting',
  components: { ImgCheckboxGroup, ImgCheckbox, ColorCheckboxGroup, ColorCheckbox, SettingItem },
  computed: {
    ...mapState({
      multipage: state => state.setting.multipage,
      theme: state => state.setting.theme,
      colorList: state => state.setting.colorList,
      fixedSiderbar: state => state.setting.fixSiderbar,
      fixedHeader: state => state.setting.fixHeader,
      layout: state => state.setting.layout,
      color: state => state.setting.color,
      user: state => state.account.user,
      fontFamilyList: state => state.setting.fontFamilyList,
      font: state => state.setting.font,
      globalFont: state => state.setting.globalFont
    }),
    fonts: {
      get () {
        return this.font
      },
      // 当localData被赋值时，它会更新data的值
      set (value) {
        this.$store.commit('setting/setFont', value)
      }
    },
    globalFonts: {
      get () {
        return this.globalFont
      },
      // 当localData被赋值时，它会更新data的值
      set (value) {
        this.$store.commit('setting/setGlobalFont', value)
      }
    },
    dark () {
      return this.theme === 'dark'
    },
    side () {
      return this.layout === 'side'
    },
    defaultValues () {
      let currentColor = this.$store.state.setting.color
      if (Array.isArray(currentColor)) {
        currentColor = currentColor[0]
      }
      const index = this.colorList.indexOf(currentColor) + 1
      return `[${index}]`
    }
  },
  methods: {
    ...mapMutations({ setSettingBar: 'setting/setSettingBar' }),
    onColorChange (values, colors) {
      if (colors.length > 0) {
        updateTheme(colors)
        this.$store.commit('setting/setColor', colors)
      }
    },
    setFont (value) {
      this.$store.commit('setting/setFont', value)
    },
    setGlobalFont (value) {
      this.$store.commit('setting/setGlobalFont', value)
    },
    handleBlur () {},
    handleFocus () {},
    filterOption (input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      )
    },
    setTheme (values) {
      this.$store.commit('setting/setTheme', values[0])
    },
    setLayout (values) {
      this.$store.commit('setting/setLayout', values[0])
    },
    setMultipage (checked) {
      this.$store.commit('setting/setMultipage', checked)
    },
    fixSiderbar (checked) {
      this.$store.commit('setting/fixSiderbar', checked)
    },
    fixHeader (checked) {
      this.$store.commit('setting/fixHeader', checked)
    },
    updateUserConfig () {
      this.$put('user/userconfig', {
        multiPage: this.multipage ? '1' : '0',
        theme: this.theme,
        fixedSiderbar: this.fixedSiderbar ? '1' : '0',
        fixedHeader: this.fixedHeader ? '1' : '0',
        layout: this.layout,
        color: this.color,
        userId: this.user.userId,
        font: this.font,
        globalFont: this.globalFont
      }).then(() => {
        this.$message.success('保存成功')
        this.setSettingBar(false)
      })
    }
  }
}
</script>

// 修改样式部分
<style lang="less" scoped>
.sider {
  background-color: #fff;
  height: 100vh;
  padding: 24px;
  display: flex;
  flex-direction: column;
  overflow: hidden;  // 新增 [!code ++]

  .scroll-container {
    flex: 1;
    overflow-y: auto;
    scrollbar-width: none; /* Firefox兼容 */
    max-height: calc(100vh - 100px);
    &::-webkit-scrollbar { /* Chrome/Safari/Edge */
      width: 0;
      background: transparent;
    }
  }

  .version-footer {
    flex-shrink: 0;
    padding: 16px 0 0; // 调整底部间距 [!code ++]
    margin-top: 12px;  // 新增 [!code ++]
  }
}
</style>



// WEBPACK FOOTER //
// src/components/setting/Setting.vue